import { api } from '@/lib/api';

import type { ApiActivity, ApiCoinPost, } from '@/lib/types';

export interface HomeFeedParams {
    Latitude?: number;
    Longitude?: number;
    RadiusKm?: number;
    Time?: 'TODAY' | 'WEEK' | 'UPCOMING';
    Page?: number;
    PageSize?: number;
}

export type HomeFeedItem =
    | {
        kind: 'activity';
        createdAt: string;
        activity: ApiActivity;
        coinPost: null;
    }
    | {
        kind: 'coin';
        createdAt: string;
        activity: null;
        coinPost: ApiCoinPost;
    };

export interface HomeFeedResponse {
    items: HomeFeedItem[];
    page: number;
    pageSize: number;
    totalItems: number;
    totalPages: number;
}

export async function getHomeFeed(params: HomeFeedParams = {}): Promise<HomeFeedResponse> {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            searchParams.set(key, String(value));
        }
    });

    const qs = searchParams.toString();

    return api<HomeFeedResponse>(`/home/feed${qs ? `?${qs}` : ''}`);
}